import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react'
import { connect } from 'react-redux';
import { Container, Row } from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import images from '../DisconnectPhotos/images'
import { goToPage, stepParams } from '../DisconnectServiceSlice'
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import { isMobile } from "react-device-detect";

function ConfirmDisconnectPage(props) {

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        reportGoogleAnalytics(props.service);
      }, [])

    function reportGoogleAnalytics(service) {
        switch (service) {
            case 'TV': 
                gaEvent(gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.category, gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.eventType, props.service)
                break;
            case 'Cellular': 
                gaEvent(gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE_CELLULAR.eventType , gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE_CELLULAR.eventParams)
                break;
            case 'Internet': 
                gaEvent(gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.category, gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.eventType, props.service)
                break;
            case 'Bundle': 
                gaEvent(gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.category, gaParams.DISCONNECT_ENTER_WE_WOULD_LIKE_TO_HELP_PAGE.eventType, props.service)
                break;
            default:
                break;
        }
    }

    function RedirectToCallbackAndReportGA() {
        if(props.service == "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE_CELLULAR.eventParams);
        }
        else {
            gaEvent(gaParams.DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE.category, gaParams.DISCONNECT_CLICK_ON_CALL_ME_BACK_HOW_CAN_WE_HELP_PAGE.eventType, props.service);
        }
        props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: false } });
    }

    function RedirectToDisconnectAndReportGA() {
        if(props.service == "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE_CELLULAR.eventParams);
        }
        else {
            gaEvent(gaParams.DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE.category, gaParams.DISCONNECT_CLICK_WANT_TO_DISCONNECT_HOW_CAN_WE_HELP_PAGE.eventType, props.service);
        }
        props.goToPage({ page: 'DISCONNECT_PAGE', params: { ...stepParams, hideHeader: false } });
    }
    

    return (
        <Container className="confirm-disconnect-root">
            <h2 className="headers-root">יש משהו שאנחנו יכולים לעשות בכל זאת?</h2>
            <h6 className="headers">חשוב לנו להקשיב ולנסות להתאים לך פתרון שישאיר אותך איתנו</h6>
            <Row className="pic-row">
                {isMobile ? <div className="mainPic"><Image src={images.weWantToHelpIcon} /></div> : <div className="mainPic"><Image src={images.weWantToHelpIconMid} /></div>}
            </Row>
            <Row className="get-back-to-me-row">
                <BtnSubmit text="כן, תחזרו אליי" onclick={() => RedirectToCallbackAndReportGA()}/>
            </Row>
            <Row className="disconnect-row">
                <div className="disconnectMeLinkDiv" onClick={() => RedirectToDisconnectAndReportGA()}>אני בכל זאת רוצה להתנתק
                    <div className="arrow"/>
                </div>
            </Row>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    disconnectTypeOfService: state.disconnectServicesBlock.disconnectTypeOfService,
    service: state.disconnectServicesBlock.serviceToDisconnect.serviceType
  });
  
const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDisconnectPage);